declare global {
  interface String {
    toNullableBoolean(): boolean | null;
  }
}
String.prototype.toNullableBoolean = function (): boolean | null {
  if (this == null) return null;
  if (this == 'null') return null;
  if (this === '1') return true;
  return this.toLowerCase() === 'true';
};
export {};
